import Vue from 'vue';
import newsComponent from './news/news.vue';
import store from '../common/js/vuex/store';
import newsStore from '../applications/news/news-vuex';
if (!store.hasModule(['newsModule'])) {
	store.registerModule('newsModule', newsStore);
}
Vue.component('news', newsComponent);
